import React, { ReactNode, useState } from 'react';
import { typeStyle } from '@carvana/showroom-css-theme';
import clsx from 'clsx';
import Caret from '../../../assets/caret-down.svg';
import styles from './detail-toggle.module.css';

export type DetailToggleProps = {
  children: ReactNode;
  header: string | ReactNode;
  headerContent?: ReactNode;
  onDetailsToggle?: (state: boolean) => void;
  id: string;
};

export const DetailToggle = ({ children, header, onDetailsToggle, headerContent, id }: DetailToggleProps) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);

    if (onDetailsToggle) {
      onDetailsToggle(!showDetails);
    }
  };

  return (
    <>
      <div
        className={styles['detail-toggle']}
        onClick={toggleDetails}
        onKeyDown={toggleDetails}
        role="button"
        tabIndex={0}
        id={id}
        data-testid={`detail-toggle-${id}`}
      >
        <div className={styles['header']}>
          <div style={typeStyle('header-s')}>{header}</div>
          <img src={Caret} alt="caret" className={clsx(showDetails && styles['up'])} />
        </div>

        {headerContent && <div className={styles['header-content']}>{headerContent}</div>}
      </div>

      {showDetails && <div className={styles['detail-toggle-details']}>{children}</div>}
    </>
  );
};
